import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { PrimeReactProvider } from 'primereact/api'
import 'primereact/resources/themes/saga-blue/theme.css' // You can change the theme
import 'primereact/resources/primereact.css'
import reportWebVitals from './reportWebVitals'
/*
import { Provider, ErrorBoundary } from '@rollbar/react'
import { UserbackProvider, useUserback } from '@userback/react'
import { ROLLBAR_KEY, ROLLBAR_ENV, USERBACK_KEY } from '@env'
*/
import NoData from './components/noData'
import {Metric, getCLS, getFCP, getLCP, getTTFB} from 'web-vitals'

function sendToGoogleAnalytics({ name,delta,value,id }:Metric) {
  // Assumes the global `gtag()` function exists, see:
  // https://developers.google.com/analytics/devguides/collection/ga4
  window.gtag('event', name, {
    // Built-in params:
    value: delta,
    // Custom params:
    metric_id: id,
    metric_value: value,
    metric_delta: delta,
  })
}

getCLS(sendToGoogleAnalytics)
getFCP(sendToGoogleAnalytics)
getLCP(sendToGoogleAnalytics)
getTTFB(sendToGoogleAnalytics)

/*
const rollbarConfig = {
  accessToken: ROLLBAR_KEY,
  environment: ROLLBAR_ENV,
  captureUncaught: true,
  captureUnhandledRejections: true,
}*/
localStorage.setItem('ENVIRONMENT','production')

interface ErrorDisplayProps {
  error: Error | null
  resetError: () => void
}

const ErrorDisplay = ({ error, resetError }: ErrorDisplayProps) => {
  /* const Userback = useUserback()

  useEffect(() => {
    Userback.setData({
      error: JSON.stringify(error),
    })
  }, [error])
  */

  return (
    <div className="d-flex flex-column align-items-center justify-content-center p-4">
      <NoData>
        <div className="text-center">
          <h5>
            There was an error showing this content. If you are looking at a user profile that profile may no longer exist on the site. Please email support@datingacrossthepond.com with any questions.
          </h5>
        </div>
      </NoData>
      <button className="btn btn-primary mt-4"
        onClick={() =>
        {
          location.reload()
          resetError()
        }}>
        Try Again
      </button>
    </div>
  )
}


/*
ReactDOM.createRoot(document.getElementById('root')!).render(
  <UserbackProvider token={USERBACK_KEY}>
    <Provider config={rollbarConfig}>
      <ErrorBoundary fallbackUI={ErrorDisplay}>
        <PrimeReactProvider>
          <App />
        </PrimeReactProvider>
      </ErrorBoundary>
    </Provider>
  </UserbackProvider>
)
*/

// Fallback rendering without Rollbar or Userback
ReactDOM.createRoot(document.getElementById('root')!).render(
  <PrimeReactProvider>
    <App />
  </PrimeReactProvider>
)

reportWebVitals(sendToGoogleAnalytics)
